<script>
import { library } from "@common/library/library";
import { componentStore } from "@common/componentStore/componentStore";

const datamapEditorConfig = {
    cId: "datamapEditor",
    cType: "datamapEditor",
    cTitle: "Datamap Editor",
    cTemplate: `<div class="datamap-editor">
                    <div class="datamap-actions"><control name="DATAMAP_ADD"></control></div>
                    <div class="datamap-list">
                        <div v-for="(data, key) in datamapItems" :key="key" class="datamap-item">
                            <div class="flow-indicator">
                                <div class="flow-indicator-line">{{}}</div>
                                <div>
                                    <div class="flow-from">{{}}</div>
                                    <div class="flow-to">{{}}</div>
                                </div>

                            </div>
                            <div>
                                <div class="datamap-item-delete" v-on:click="datamapDelete(key)">
                                    <span class="e-icons e-delete"></span>
                                </div>
                                <div class="datamap-item-field field-from">
                                    <control :name="'DATAMAP_FROM__'+key" :items="dataFrom" :value="data.fromValue"></control>
                                </div>
                                <div class="datamap-item-field field-to">
                                    <control :name="'DATAMAP_TO__'+key" :items="dataTo" :value="data.toValue"></control>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>`,
    controls: [
        {
            name: 'DATAMAP_FROM',
            type: 'dropdowntree',
            placeholder: 'From Data',
            floatLabelType: 'Always',
            allowFiltering: true,
            onchange: 'changeDatamap',
            itemsSort: {
                sortBy: 'text'
            },
            fields: {
                text: 'text',
                value: 'value',
                hasChildren: 'hasChild',
                parentValue: 'pId'
            }
        },
        {
            name: 'DATAMAP_TO',
            type: 'dropdowntree',
            placeholder: 'To Data',
            floatLabelType: 'Always',
            onchange: 'changeDatamap',
            allowFiltering: true,
            itemsSort: {
                sortBy: 'text'
            },
            fields: {
                text: 'text',
                value: 'value',
                hasChildren: 'hasChild',
                parentValue: 'pId'
            }
        },
        {
            name: 'DATAMAP_VALUE',
            type: 'string',
            oninput: 'changeDatamap'
        },
        {
            name: 'DATAMAP_ADD',
            type: 'button',
            cssClass: 'e-info',
            width: '120px',
            label: 'Add Datamap',
            onclick: 'datamapAdd'
        }
    ]
};

const datamapEditorCmp = {
    name: 'datamapEditor',
    props: {
        componentId: {
            default: null
        },
        datamapItems: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            datamapList: [],
            dataFrom: null,
            dataTo: null,
            component: null
        };
    },
    methods: {
        setDatamapItems() {
            let items = [];
            if (this.datamapList) {
                for (let i in this.datamapList) {
                    if (i === 'length') continue;
                    items[i] = library.cloneObj(this.datamapList[i]);
                    let value = "";
                    if (this.datamapList[i].from) {
                        value = this.datamapList[i].from + '__' + this.datamapList[i].property;
                    }
                    items[i].fromValue = value;
                    value = "";
                    if (this.datamapList[i].to) {
                        value = this.datamapList[i].to + '__' + this.datamapList[i].as;
                    }
                    items[i].toValue = value;
                }
            }
            if (!library.isEqualObj(this.datamapItems, items)) {
                this.datamapItems = items;
                this.$emit('update:propDatamapItems', this.datamapItems);
            }
        },
        changeDatamap(event) {
            if (event && event.e === null) return;
            let tmp = [];
            for (let i in this.datamapList) {
                if (i === 'length') continue;
                let tmpFromValue = Array.isArray(this.controls['DATAMAP_FROM__' + i].value)
                    ? this.controls['DATAMAP_FROM__' + i].value[0]
                    : this.controls['DATAMAP_FROM__' + i].value;
                let tmpFrom = tmpFromValue;
                let tmpProperty;
                if (tmpFromValue) {
                    tmpFrom = tmpFromValue.split('__')[0];
                    tmpProperty = tmpFromValue.split('__')[1];
                }
                let tmpToValue = this.controls['DATAMAP_TO__' + i].value;
                let tmpTo = tmpToValue;
                let tmpAs;
                if (tmpToValue) {
                    tmpTo = tmpToValue.split('__')[0];
                    tmpAs = tmpToValue.split('__')[1];
                }
                if (!tmpAs) tmpAs = tmpProperty;
                tmp.push({
                    property: tmpProperty,
                    from: tmpFrom,
                    to: tmpTo,
                    as: tmpAs
                });
            }
            if (!library.isEqualObj(this.datamapList, tmp)) {
                this.datamapList = library.cloneObj(tmp);
                this.setDatamapItems();
            }
        },
        datamapAdd() {
            let tmp = library.cloneObj(this.datamapList);
            tmp.push({});
            this.datamapList = [];
            this.datamapList = [...tmp];
            this.setDatamapItems();
        },
        datamapDelete(key) {
            let tmp = library.cloneObj(this.datamapList);
            tmp.splice(key, 1);
            this.controls['DATAMAP_FROM__' + key].value = "";
            this.controls['DATAMAP_TO__' + key].value = "";
            this.datamapList = library.cloneObj(tmp);
            this.setDatamapItems();
        },
        async onPropsUpdate() {
            if (this.componentId) {
                if (!this.datamapList.length) {
                    let config = await componentStore.getConfig(this.componentId);
                    if (config.layoutDatamap) {
                        this.datamapList = library.cloneObj(config.layoutDatamap);
                        this.setDatamapItems();
                    }
                }
                this.getComponentsData();
            }
        },
        async getComponentsData() {
            let configs = componentStore.get('componentsConfig');
            let config = await componentStore.getConfig(this.componentId);
            let itemsTo = [];
            let itemsFrom = [];
            let addedParentProps = {};
            let addParentOption = (value, text, from, to) => {
                if (!addedParentProps[value]) {
                    addedParentProps[value] = true;
                    let parentOption = {
                        value,
                        text,
                        hasChild: true,
                        selectable: false,
                        htmlAttributes: { 'prevent-select': 'true' },
                    };
                    if (from) itemsFrom.push(parentOption);
                    if (to) itemsTo.push(parentOption);
                }
            };
            let setProps = (cId, cType, tabLabel) => {
                if (!tabLabel) tabLabel = '';
                // Add props from component's code file eg: something.vue
                let pId = 'props_' + cId;
                addParentOption(pId, 'Props: ' + cId);
                if (cType && typeof configs[cType] !== 'undefined' && typeof configs[cType].props !== 'undefined') {
                    for (let j in configs[cType].props) {
                        if (j === 'length') continue;
                        let text = cId + ': ' + j + tabLabel;
                        itemsTo.push({
                            value: cId + '__' + j,
                            text,
                            cId,
                            pId
                        });
                    }
                }
                // Add global props from componentGlobalMixins
                let globalProps = ['contextVolId', 'contextOppId', 'contextOrgId', 'contextShiftId'];
                globalProps.forEach((prop) => {
                    itemsTo.push({
                        value: cId + '__' + prop,
                        text: prop,
                        cId,
                        pId
                    });
                });
            };
            let setData = (cId, cType, tabLabel) => {
                if (!tabLabel) tabLabel = '';
                // set Data
                let pId = 'data_' + cId;
                addParentOption(pId, 'Data: ' + cId, true);
                if (cType && typeof configs[cType] !== 'undefined' && typeof configs[cType].data === 'function') {
                    let data = configs[cType].data();
                    for (let dKey in data) {
                        if (dKey === 'length') continue;
                        let text = 'Data: ' + cId + ': ' + dKey + tabLabel;
                        itemsFrom.push({
                            value: cId + '__' + dKey,
                            text,
                            cId,
                            pId
                        });
                    }
                }
            };
            let setConfigComponents = async (tmpFromNames, cId, tabLabel) => {
                if (!tabLabel) tabLabel = '';
                // use getConfig to get cType
                let comp = await componentStore.getConfig(cId);
                let cType = comp.cType;
                if (!cType || !cId) return;
                // Set Props
                setProps(cId, cType, tabLabel);
                // Set Data
                setData(cId, cType, tabLabel);
                // Set Props specific to cType
                if (cType === 'layoutContainer') {
                    let pId = 'storeProp_' + cId;
                    addParentOption(pId, 'Store Props: ' + cId, false, true);
                    for (let j in comp.storeProps) {
                        if (j === 'length') continue;
                        let property = comp.storeProps[j].property;
                        let text = 'Store Prop: ' + cId + ': ' + property + tabLabel;
                        itemsTo.push({
                            value: cId + '__' + property,
                            text,
                            cId,
                            pId
                        });
                    }
                    let text = 'Store Prop: ' + cId + ': layoutId' + tabLabel;
                    itemsTo.push({
                        value: cId + '__layoutId',
                        text,
                        cId,
                        pId
                    });
                }
                else if (comp.cType === 'tabList') {
                    if (Array.isArray(comp.tabs)) {
                        let tabComponents = [];
                        comp.tabs.forEach((tab) => {
                            if (Array.isArray(tab.components)) {
                                tab.components.forEach((tabComponent, index) => {
                                    tabComponents.push({
                                        component: tabComponent,
                                        index: index
                                    });
                                });
                            }
                        });
                        tabComponents.forEach(async (tab) => {
                            let tabLabel = ` (tab ${tab.index})`;
                            await setConfigComponents(tmpFromNames, tab.component.cId, tabLabel);
                        });
                    }
                }

                // eslint-disable-next-line no-await-in-loop
                let tmpConfig = await componentStore.getConfig(cId);
                for (let j in tmpConfig.layoutDatamap) {
                    if (j === 'length') continue;
                    if (tmpConfig.layoutDatamap[j].to === 'thisStore') {
                        tmpFromNames.push(tmpConfig.layoutDatamap[j].as);
                        let pId = 'storeProps';
                        addParentOption(pId, 'Store Props: ' + this.componentId, true);
                        itemsFrom.push({
                            value: 'thisStore__' + tmpConfig.layoutDatamap[j].as,
                            text: tmpConfig.layoutDatamap[j].as + ' ( ' + tmpConfig.layoutDatamap[j].from + ' )',
                            cId: 'thisStore',
                            pId
                        });
                    }
                }
            };
            let setItemsTo = async () => {
                let tmpConfig = await componentStore.getConfig(config.thisStoreCId);
                if (tmpConfig.storeProps && tmpConfig.storeProps.length) {
                    let pId = 'storeProps';
                    addParentOption(pId, 'Store Props: ' + this.componentId, false, true);
                    for (let i in tmpConfig.storeProps) {
                        if (i === 'length') continue;
                        itemsTo.push({
                            value: 'thisStore__' + tmpConfig.storeProps[i].property,
                            text: 'thisStore: ' + tmpConfig.storeProps[i].property,
                            cId: 'thisStore',
                            pId
                        });
                    }
                }
            };
            if (config.cType === 'layoutContainer') {
                let fromNames = [];
                for (let i in config.components) {
                    if (i === 'length') continue;
                    // eslint-disable-next-line no-await-in-loop
                    await setConfigComponents(fromNames, config.components[i].cId);
                }
                let pId = 'storeProps';
                let cId = 'thisStore';
                let pText = 'Store Props: ' + this.componentId;
                addParentOption(pId, pText, true, true);
                for (let i in config.storeProps) {
                    if (i === 'length') continue;
                    let property = config.storeProps[i].property;
                    let text = pText + ': ' + property;
                    let value = 'thisStore__' + property;
                    if (fromNames.indexOf(config.storeProps[i].property) !== -1) continue;
                    fromNames.push(config.storeProps[i].property);
                    // eslint-disable-next-line object-curly-newline
                    let option = { value, text, cId, pId };
                    itemsFrom.push(option);
                    // eslint-disable-next-line object-curly-newline
                    itemsTo.push(option);
                }
                itemsFrom.push({
                    value: 'thisStore__layoutId',
                    text: pText + ': layoutId',
                    cId,
                    pId
                });
            } else {
                if (configs[config.cType] && typeof configs[config.cType].data === 'function') {
                    let data = configs[config.cType].data();
                    let cId = config.cId;
                    let pId = 'data_' + cId;
                    let pText = 'Data: ' + cId;
                    addParentOption(pId, pText, true);
                    for (let i in data) {
                        if (i === 'length') continue;
                        let text = pText + ': ' + i;
                        let value = config.cId + '__' + i;
                        // eslint-disable-next-line object-curly-newline
                        itemsFrom.push({ value, text, cId, pId });
                    }
                    if (!config.thisStoreCId && this.layoutStoreId) {
                        config.thisStoreCId = this.layoutStoreId.split('_')[0];
                    }
                    if (typeof config.thisStoreCId !== 'undefined') {
                        await setItemsTo();
                    }
                }
            }
            this.dataTo = itemsTo;
            this.dataFrom = itemsFrom;
        },
        async onLoad() {
            if (this.componentId) {
                this.component = await componentStore.getConfig(this.componentId);
            }
        }
    }
};

componentStore.initComponent(datamapEditorCmp, datamapEditorConfig);
export { datamapEditorConfig, datamapEditorCmp };
export default datamapEditorCmp;
</script>

<style scoped>
.datamap-editor {
    position: relative;
    top: -25px;
    border-bottom: 2px solid #f0f0f0;
}
.datamap-editor .datamap-item {
    padding: 5px;
    margin-bottom: 1px;
    border-radius: 3px;
    border: 1px solid #888;
    display: block;
    position: relative;
    min-height: 114px;
    background: #f7f7f7;
}
.datamap-editor .datamap-item:hover {
    background: #fff;
}
.datamap-editor .datamap-item-delete {
    height: 25px;
    width: 25px;
    display: flex;
    position: absolute;
    right: 1px;
    top: 1px;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    background-color: #e0e0e0;
    border-radius: 0 0 0 50%;
    cursor: pointer;
    z-index: 1;
    color: darkred;
}
.datamap-item-field {
    padding: 0 20px;
}
.flow-indicator {
    width: 0;
    height: 0;
    position: relative;
    overflow: visible;
}
.flow-indicator-line {
    width: 5px;
    float: left;
    height: 57px;
    position: relative;
    top: 5px;
    border-width: 2px 0 2px 2px;
    border-style: solid;
    border-color: #e55871;
}
.flow-indicator .flow-from, .flow-indicator .flow-to {
    content: '';
    display: inline-block;
    width: 0;
    height: 0;
    position: relative;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
}
.flow-indicator .flow-from {
    border-right: 10px solid #e55871;
    margin-bottom: 37px;
    left: -1px;
}
.flow-indicator .flow-to {
    border-left: 10px solid #e55871;
}
.datamap-actions {
    text-align: right;
    margin-bottom: 3px;
}
.datamap-actions .control.e-control {
    display: inline-block;
}
</style>
